{
	"title": "Прогресс",
	"subtitle": "Аналитика обучения и статистика",
	"overview": {
		"title": "Обзор",
		"thisWeek": "За неделю",
		"thisMonth": "За месяц",
		"allTime": "За всё время"
	},
	"stats": {
		"materialsStudied": "Изучено материалов",
		"cardsReviewed": "Карточек повторено",
		"quizzesCompleted": "Тестов пройдено",
		"minutesStudied": "Минут обучения",
		"averageScore": "Средний балл"
	},
	"range": {
		"label": "Период",
		"week": "Неделя",
		"month": "Месяц",
		"year": "Год"
	},
	"kpi": {
		"streakLabel": "Стрик",
		"streakValue": "{days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
		"streakValueLabel": "{days, plural, one {день подряд} few {дня подряд} many {дней подряд} other {дня подряд}}",
		"streakHint": "До рекорда: {days, plural, one {# день} few {# дня} many {# дней} other {# дней}}",
		"streakHintAtRecord": "Личный рекорд!",
		"masteryLabel": "Освоение",
		"masteryHint": "освоено за {range}",
		"minutesLabel": "Время",
		"minutesValue": "{hours} ч {minutes} мин",
		"minutesShort": "{minutes} мин",
		"minutesHint": "обучения за {range}",
		"activitiesLabel": "Активностей",
		"activitiesHint": "активностей выполнено",
		"moreDetails": "Подробнее",
		"trendUp": "▲ {value}",
		"trendDown": "▼ {value}",
		"trendNone": "—"
	},
	"charts": {
		"mastery": "Освоение во времени",
		"studyTime": "Время за день",
		"timeSpent": "Минуты обучения",
		"srsReviewed": "Повторённые карточки",
		"minutes": "мин",
		"retention": "Усвоение материала",
		"weakAreas": "Слабые темы",
		"emptyHint": "Данные появятся после первых сессий"
	},
	"heatmap": {
		"title": "Активность за {days} дней",
		"cardTitle": "Твой ритм",
		"activeDays": "{active} из {total} активных дней",
		"cellActive": "{date} — {minutes, plural, one {# минута} few {# минуты} many {# минут} other {# минут}}",
		"cellEmpty": "{date} — без занятий",
		"empty": "Ритм появится после первых занятий",
		"less": "Меньше",
		"more": "Больше"
	},
	"mastery": {
		"empty": "Пока нет данных по темам"
	},
	"noExam": "Нет ближайшего экзамена",
	"modules": {
		"title": "По материалам",
		"all": "Все материалы",
		"untitled": "Без названия",
		"columns": {
			"material": "Материал",
			"cards": "Активности",
			"mastery": "Освоение"
		},
		"empty": "Пока нет материалов",
		"emptyHint": "Загрузи первый материал — статистика появится автоматически",
		"mobileMeta": "{cardsDone}/{cardsTotal} активностей",
		"sortBy": "Сортировать",
		"sort": {
			"mastery": "Освоение",
			"progress": "По прогрессу",
			"recent": "По активности"
		}
	},
	"feed": {
		"title": "Активность",
		"empty": "Нет активности",
		"emptyHint": "Здесь появятся твои недавние занятия",
		"showMore": "Показать ещё",
		"durationMin": "{minutes} мин",
		"kind": {
			"material.uploaded": "Загружен материал",
			"material.processed": "Готов конспект",
			"note.generated": "Конспект сгенерирован",
			"flashcard-set.generated": "Набор карточек создан",
			"quiz.completed": "Пройден тест",
			"tutor.session": "Сессия с репетитором",
			"audio.generated": "Аудио готово",
			"essay.graded": "Эссе оценено",
			"study-plan.completed-activity": "Активность в плане",
			"recording.completed": "Запись лекции"
		}
	},
	"empty": {
		"title": "Прогресс появится после первой сессии",
		"body": "Начни с загрузки материала или повторения карточек",
		"upload": "Загрузить материал",
		"recommendations": "К рекомендациям"
	},
	"tabs": {
		"feed": "Лента",
		"recommendations": "Рекомендации"
	},
	"actions": {
		"export": "Экспорт",
		"exportCsv": "CSV",
		"exportPdf": "PDF",
		"exportJson": "JSON"
	},
	"error": {
		"title": "Не удалось загрузить",
		"retry": "Повторить"
	},
	"streaks": {
		"title": "Стрик",
		"current": "{days, plural, one {# день} few {# дня} many {# дней} other {# дня}} подряд",
		"longest": "Лучший: {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
		"dailyGoal": "Цель на день",
		"goalReached": "Цель выполнена!",
		"minutesLeft": "Осталось {minutes} мин",
		"frozen": "Стрик заморожен",
		"freezesLeft": "Заморозок осталось: {count}"
	},
	"recommendations": {
		"title": "Что повторить сегодня",
		"subtitle": "Адаптивные рекомендации",
		"empty": "Нет рекомендаций",
		"refresh": "Обновить"
	},
	"intro": {
		"title": "Откуда берутся эти цифры",
		"body": "Всё считается само по вашим действиям: повторам, тестам, минутам. Отмечать пройденное вручную не нужно.",
		"bullets": [
			"Освоенность темы — из ответов, а не из отметок «прочитано»",
			"Серия держится дневной целью в минутах",
			"Тепловая карта показывает ритм занятий"
		]
	}
}
